import { axios } from '@/utils/request'

export default {
    create(info){
        return axios.post('/api/services/app/BaseInfo/Create',info)
    },
    update(info){
        return axios.put('/api/services/app/BaseInfo/Update',info)
    },
    delete(id){
        return axios.delete('/api/services/app/BaseInfo/Delete?Id='+id)
    },
    get(id){
        return axios.get('/api/services/app/BaseInfo/Get?Id='+id)
    },
    getAll(page){
        return axios.get('/api/services/app/BaseInfo/GetAll',{params:page})
    },
    getPage(page){
        return axios.get('/api/services/app/BaseInfo/GetPage',{params:page})
    }
}